export default __webpack_public_path__ + "388a693342bb5cabc9408e54b3a6c6af.png";